export default "<p>owner-medical-appointment-detail works!</p>\n"